import User from './user';

const stores = {
    user: User,
};

export default stores;
